/**
 * add comma as a thousands separator to a number
 */
function numberWithCommas(num: number): string {

  if(num) return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return '0'
}

function isOwnerViewReadOnly(): boolean {
  const inputEl = document.getElementById('ownerViewReadOnlyMode') as HTMLInputElement | null;
  let result = false;
  if(inputEl && inputEl.value == 'true') {
    result = true;
  }
  return result;
}

function isVOAReadOnly(): boolean {
   const reactHolder = document.getElementById("rtWebPanel");
   if(!reactHolder) {
    console.log('React holder element not found, defaulting VOA read-only mode to false');
    return false;
   }
  const isVOAReadOnly = reactHolder.getAttribute('data-allow-reservation') as string | null;
  console.log('allow reservation Attribute', isVOAReadOnly);
    let result = false;
  if(isVOAReadOnly && isVOAReadOnly === 'false') {
    result = true;
  }
  return result;
   
}

function parseJwt(token: string) {
  var base64Payload = token.split('.')[1];
  var payload = Buffer.from(base64Payload, 'base64');
  return JSON.parse(payload.toString());
}

function resetSessionKeys(keys: string[] = []){
  console.log("==> Resetting prev session keys");
  keys.forEach((key) => {
    sessionStorage.removeItem(key);
  });
};

export {
  numberWithCommas,
  isOwnerViewReadOnly,
  parseJwt,
  isVOAReadOnly,
  resetSessionKeys
};